import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const GET_ENTITY_LISTMETADATA = `[${ModuleConfiguration.moduleName}] Get Entity List Metadata`;

export class GetEntityListMetadataAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_ENTITY_LISTMETADATA;

  constructor(public payload: { entityKey: string, scope?: string }) {}
}




// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/GetEntityListMetadataAction.ts